import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const IDLE_TIME = 3 * 60 * 1000 // 3 minutes
const WARNING_TIME = IDLE_TIME - 5000 // show toast 5 sec before

const useIdleRedirect = (redirectPath = '/tasks') => {
  const navigate = useNavigate()

  const idleTimerRef = useRef(null)
  const warningTimerRef = useRef(null)

  const clearTimers = () => {
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current)
    if (warningTimerRef.current) clearTimeout(warningTimerRef.current)
  }

  const resetTimers = () => {
    clearTimers()

    // Warning toast
    warningTimerRef.current = setTimeout(() => {
      toast.warn('You will be redirected due to inactivity in 5 seconds!', {
        toastId: 'idle-warning', // prevent duplicates
        autoClose: 5000,
      })
    }, WARNING_TIME)

    // Final redirect
    idleTimerRef.current = setTimeout(() => {
      navigate(redirectPath)
    }, IDLE_TIME)
  }

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart']

    events.forEach((event) => window.addEventListener(event, resetTimers))

    resetTimers() // start on mount

    return () => {
      clearTimers()
      events.forEach((event) => window.removeEventListener(event, resetTimers))
    }
  }, [])

  return null
}

export default useIdleRedirect
